import Skeleton from "@/components/shared/skeleton";

const ProblemMemoSkeleton: React.FC = () => {
  return (
    <div className="">
      <div className="flex gap-16">
        <div className="flex gap-16">
          <Skeleton className="h-[6.5rem] min-w-[8.6rem]" />
          <div className="space-y-8">
            <Skeleton className="h-12 w-40 rounded-md" />
            <Skeleton className="h-12 w-[8rem] rounded-md" />
            <Skeleton className="h-12 w-[20rem] rounded-md" />
          </div>
        </div>
      </div>
      <Skeleton className="mt-16 h-40 w-full rounded-md" />
    </div>
  );
};

export default ProblemMemoSkeleton;
